module.exports = __webpack_public_path__ + "static/media/geresh.b3201f41.svg";